import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupingRemover'
})

export class GroupingRemoverPipe implements PipeTransform {
    transform(value: string, args: any[]): string {
        if(value) {
          return value.replace(/\./g, '').replace(/,/g,'');
        }
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/grouping-remover.pipe.ts